import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ chartData }) => {
  const data = {
    labels: ["Revenue", "Expenses"],
    datasets: [
      {
        //   label: ["Revenue", "Expenses"],
        // data: [89000, 68000],
        data: [chartData?.revenue, chartData?.expense],
        backgroundColor: ["rgba(40, 144, 0, 0.5)", "rgba(255, 99, 132, 0.5)"],
        //   borderColor: ["rgba(255, 99, 132, 0)", "rgba(54, 162, 235, 0)"],
        //   borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        enabled: true,
      },
    },
    cutout: "85%",
  };

  return (
    // <div style={{ width: "300px", height: "300px" }}>
    <Doughnut data={data} options={options} />
    // </div>
  );
};

export default DoughnutChart;
